import {
  addDoc,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp
} from "firebase/firestore";
import { db } from "../firebase";
import { clearCachedValue, getCachedValue, setCachedValue } from "../utils/cache";

const INCOME_CACHE_KEY = "bauheld_recent_income_v1";
const EXPENSES_CACHE_KEY = "bauheld_recent_expenses_v1";
const RECENT_TTL_MS = 2 * 60 * 1000;

export const addIncomeEntry = async (data) => {
  await addDoc(collection(db, "income"), {
    ...data,
    amount: Number(data.amount || 0),
    createdAt: serverTimestamp()
  });

  clearCachedValue(INCOME_CACHE_KEY);
};

export const addExpenseEntry = async (data) => {
  await addDoc(collection(db, "expenses"), {
    ...data,
    amount: Number(data.amount || 0),
    createdAt: serverTimestamp()
  });

  clearCachedValue(EXPENSES_CACHE_KEY);
};

export const getRecentIncome = async (force = false) => {
  if (!force) {
    const cached = getCachedValue(INCOME_CACHE_KEY, RECENT_TTL_MS);
    if (cached) return cached;
  }

  const q = query(collection(db, "income"), orderBy("createdAt", "desc"), limit(12));
  const snap = await getDocs(q);
  const rows = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  setCachedValue(INCOME_CACHE_KEY, rows);
  return rows;
};

export const getRecentExpenses = async (force = false) => {
  if (!force) {
    const cached = getCachedValue(EXPENSES_CACHE_KEY, RECENT_TTL_MS);
    if (cached) return cached;
  }

  const q = query(collection(db, "expenses"), orderBy("createdAt", "desc"), limit(12));
  const snap = await getDocs(q);
  const rows = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  setCachedValue(EXPENSES_CACHE_KEY, rows);
  return rows;
};
